// extracted by mini-css-extract-plugin
module.exports = {"message":"message__YFL2z","messageIcon":"messageIcon__HnQAu"};